module.exports = __webpack_public_path__ + "img/shareCardImg.dfb786f6.png";